module.exports = __webpack_public_path__ + "media/orderfood-notify.81211ebb.mp3";